import React from 'react'
import Grid from '@mui/material/Grid';
import RowOfCars from './RowOfCars';
import { v4 as uuidv4 } from 'uuid';


export default function FullGrid(props) {
    var carsThatPassFilter = []
    //remove cars that don't meet the selected filters
    var meetsFilters = function() {
        for (let i=0; i<props.data.length; i++){
            var meetsRequirements = true;
            var price = props.data[i].Price.replace(',', '');
            price = parseInt(price)
            if (price > props.filters.price){
                meetsRequirements = false;
            }

            var seatNumber = props.data[i].Seats;
            seatNumber = parseInt(seatNumber)
            if (seatNumber < props.filters.seatNumber){
                meetsRequirements = false;
            }

            var electricRange = props.data[i].ElectricRange.replace(' mi.')
            electricRange = parseInt(electricRange);
            electricRange = isNaN(electricRange) ? 0 : electricRange;
            if (electricRange < props.filters.range) {
                console.log('doesnt meet')
                meetsRequirements = false;
            }

            var batterySize = props.data[i].BatterySize.replace(' kwh')
            batterySize = parseInt(batterySize);
            batterySize = isNaN(batterySize) ? 0 : batterySize;
            if (batterySize < props.filters.batterySize) {
                meetsRequirements = false;
            }

            var typeOfCar = props.data[i].FuelType
            if (props.filters.typeOfCar !== "All" && typeOfCar !== props.filters.typeOfCar) {
                meetsRequirements = false;
            }


            if (meetsRequirements){
                carsThatPassFilter.push(props.data[i])
            }
        }
    }

    meetsFilters();

    var slicedArrays = []
    for (let i=0; i<carsThatPassFilter.length; i++){
        //push every 4 elements into a separate array to form a RowOfCars
        var slicedArray = []
        if (i%4===0 && i!==0){
            slicedArray = carsThatPassFilter.slice(i-4,i);
            slicedArrays.push(slicedArray)
        }
        //if there are any remaining cars then populate those too
        if(i===carsThatPassFilter.length-1){
            var lastIndex = slicedArrays.length*4;
            slicedArray = carsThatPassFilter.slice(lastIndex,i+1)
            slicedArrays.push(slicedArray)
        }
    }

    return (
            <Grid container spacing={2}>
                <p>Results: {carsThatPassFilter.length}</p>
                <Grid item xs={12}>
                    {slicedArrays.map(function(slicedArray){
                        return <RowOfCars key={uuidv4()} data={slicedArray} />;
                    })}
                </Grid>
            </Grid>
    )
}
